import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../firebase'
import { dateFormatterShort } from '../../../helpers/dateFormatter';
import { totalIncomeCalculator } from '../../../helpers/financeCalculator';
import { numberFormatter } from '../../../helpers/numberFormatter';
import StateContext from '../../../StateContext'

function UserBudgetExpenses({setTotalExpenses, month}) {

    const appState = useContext(StateContext)

    const [incomes, setIncomes] = useState([]);
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (appState.userId) {
            try {
                const budgetIncomeRef = firestore.collection("users").doc(appState.userId).collection("budget");

                if (month) {
                    budgetIncomeRef.where("type", "==", "expense").where("month", "==", month.number).orderBy("date", "asc").onSnapshot(({docs}) => {
                        const incomes = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setIncomes(incomes);
                        if (incomes.length > 0) {
                            const totalIncome = totalIncomeCalculator(incomes);
                            if (totalIncome) {
                                setTotalExpenses(-totalIncome);
                            } else {
                                setTotalExpenses(0)
                            }
                        }

                        
                    })
                } else {
                    budgetIncomeRef.where("type", "==", "expense").orderBy("date", "asc").onSnapshot(({docs}) => {
                        const incomes = docs.map(doc => {
                            return {id: doc.id, ...doc.data()}
                        })
                        setIncomes(incomes);
                        const totalIncome = totalIncomeCalculator(incomes);
                        setTotalExpenses(-totalIncome);
                    })
                }

            } catch (error) {
                console.log(error)   
            }
        }


    }, [appState.userId, month])

    async function deleteHandler(e, id) {
        e.preventDefault()
        try {
            const budgetIncomeRef = firestore.collection("users").doc(appState.userId).collection("budget").doc(id);
            budgetIncomeRef.delete();
        } catch (error) {
            
        }

    }
    
    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    function formatDescription(description) {
        let newDescription
        if (description) {
            const descriptionArray = description.split(" ")
            newDescription = descriptionArray.reduce((acc, cur) => {
                let total = acc + cur
                if (total.length < 10) {
                    return acc + " " + cur
                } else {
                    return acc + "..."
                }
            })
        }
        return newDescription
    }

    useEffect(() => {
        formatDescription("Ole Petter Hjønnevåg Kyrkjebø")
    }, [])

    return (
        <div>
            <div onClick={toggle} className="card card-header bg-lightgrey">
                <div>
                    Utgifter <span className="float-right"><i className={show ? "fa fa-chevron-down" : "fa fa-chevron-up"}></i> </span> 
                </div>
            </div>
            <br />
            {show && (
                <div className="card card-body">
                    {incomes?.map((income, index) => {
                        return (
                            <div key={index}>
                                <span className="font-weight-bold">{dateFormatterShort(income.date)} </span>
                                <span>{formatDescription(income.description)} </span>
                                
                                <span className="float-right text-danger">-{numberFormatter(income.sum)}
                                <Link to={`/budget/edit/${income.id}`}> <i className="fas fa-edit text-primary"></i> </Link>
                                <i onClick={(e) => deleteHandler(e, income.id)} className="fas fa-trash text-danger"></i>
                                </span>
                                
                                
                                
                                <hr />
                            </div>
                        )
                    })}
                    <div>
                        <span className="font-weight-bold">Totale utgifter </span>
                        
                        <span className="float-right text-danger font-weight-bold">-{totalIncomeCalculator(incomes)} </span>
                        <hr />
                    </div>
                </div>
            )}
            {!show && (
                <div>
                    <span className="font-weight-bold">Totale utgifter </span>
                    
                    <span className="float-right text-danger font-weight-bold">-{totalIncomeCalculator(incomes)} </span>
                    <hr />
                </div>
            )}
        </div>
    )
}
export default UserBudgetExpenses